export default __webpack_public_path__ + "static/media/homepage_16.b34ece71.png";